import { useEffect, useState, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const STATUS_LABELS = {
  available: "Verfügbar",
  request: "Auf Anfrage",
  booked: "Ausgebucht",
  unavailable: "Nicht verfügbar",
};

export const STATUS_ORDER = ["available", "request", "booked", "unavailable"];

// Tailwind safelist-friendly: tone colors
export const STATUS_DOT_CLASS = {
  available: "bg-emerald-500",
  request: "bg-yellow-400",
  booked: "bg-red-600",
  unavailable: "bg-[#2C2A26]",
};

export default function useAvailability() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const refetch = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await axios.get(`${API}/availability`);
      setItems(data);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refetch();
  }, [refetch]);

  // Compute dates per status as Date[] usable with react-day-picker modifiers
  const byStatus = STATUS_ORDER.reduce((acc, s) => {
    acc[s] = items
      .filter((it) => it.status === s)
      .map((it) => parseLocalDate(it.date));
    return acc;
  }, {});

  // status lookup by yyyy-mm-dd
  const statusOf = (date) => {
    if (!date) return null;
    const key = toYMD(date);
    const found = items.find((it) => it.date === key);
    return found?.status || null;
  };

  return { items, loading, refetch, byStatus, statusOf };
}

export function toYMD(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

function parseLocalDate(s) {
  const [y, m, d] = s.split("-").map(Number);
  return new Date(y, m - 1, d);
}

// Tailwind classes applied to react-day-picker via modifiersClassNames.
// These set the cell background + text contrast for each status.
export const AVAILABILITY_MODIFIER_CLASSES = {
  available:
    "!bg-emerald-500/20 !text-emerald-900 hover:!bg-emerald-500/30",
  request:
    "!bg-yellow-300 !text-yellow-950 hover:!bg-yellow-400",
  booked:
    "!bg-red-600/25 !text-red-950 hover:!bg-red-600/25",
  unavailable:
    "!bg-[#2C2A26] !text-[#FAFAF7] hover:!bg-[#2C2A26]",
};
